import bankingimage from "../assets/images/offering/banking-intelligence.png";
import productdevelop from "../assets/images/offering/product-develop.png";
import productImplementation from "../assets/images/offering/product-Implementation.png";
import managedinfra from "../assets/images/offering/managed-infra.png";
import managedinfras from "../assets/images/offering/managedinfra.png";
import complaince from "../assets/images/offering/complaince.png";
import data from "../assets/images/offering/data-sta.png";
import dataplatform from "../assets/images/offering/data-platform.png";
import datainte from "../assets/images/offering/data-inte.png";
import genai from "../assets/images/offering/gen-ai.png";
import agentai from "../assets/images/offering/agent-ai.png";
import inte from "../assets/images/offering/inte.png";
import inferiq from "../assets/images/offering/inferiq.png";
import cloudsecurity from "../assets/images/offering/cloud-security.png";
import migrationservice from "../assets/images/offering/migration-service.png";
import managedservice from "../assets/images/offering/managed-service.png";
import cloudnative from "../assets/images/offering/cloud-native.png";
import cloudad from "../assets/images/offering/cloud-ad.png";
import open from "../assets/images/offering/open.png";
import productdev from "../assets/images/offering/product-dev.png";
import custom from "../assets/images/offering/custom.png";
import system from "../assets/images/offering/system.png";
import risk from "../assets/images/offering/risk.png";
import identify from "../assets/images/offering/identify.png";
import threat from "../assets/images/offering/threat.png";
import endpoint from "../assets/images/offering/endpoint.png";
import secure from "../assets/images/offering/secure.png";
import datasecure from "../assets/images/offering/datasecure.png";

export const bankingSolutionTabs = [
  {
    id: 1,
    tabTitle: "Banking Intelligence",
    heading: "Intelligent banking for faster, smarter decision-making",
    content:
      "Transform financial operations with next-gen AI-powered Banking Intelligence. Unify fragmented data ecosystems and accelerate financial data processing with precision-driven analytics. Deploy advanced decision intelligence to optimize and strengthen regulatory compliance and deliver hyper-personalized banking experiences at scale.",
    img: bankingimage,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "39,55,97",
    features: [
      "Risk Intelligence",
      "Regulatory Compliance Automation",
      "Generative AI for Financial Insights",
      "Intelligent Fraud Detection",
    ],
  },
  {
    id: 2,
    tabTitle: "Product Development",
    heading: "Build High Performance Banking Products",
    content:
      "Redefine banking product development with AI-driven engineering, domain intelligence, and agile methods. Remove bottlenecks, accelerate deployment, and enable seamless integration. Build scalable financial solutions—from loan origination to servicing—for institutions of all sizes.",
    img: productdevelop,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "26,37,93",
    features: [
      "AI-Native Product Architecture",
      "Gen AI-driven operations transformation",
      "Intelligent API Ecosystem",
      "Built for Cloud Deployment ",
      "Agile Development with AIOps",
    ],
  },
  {
    id: 3,
    tabTitle: "Product Implementation",
    heading: "Faster Product Deployment for Modern Banking ",
    content:
      "Eliminate deployment bottlenecks with AI-enabled automation and deep banking expertise. Overcome integration complexities, optimize configurations, and ensure regulatory-compliant implementations. From seamless go-live to full-scale adoption, enable frictionless product rollouts—empowering FinTechs to innovate without constraints.",
    img: productImplementation,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "61, 0, 86",
    features: [
      "AI-Optimized Deployment Strategies ",
      "Seamless Core System Integration ",
      "Security-First, Compliance-Ready ",
      "Comprehensive Support & Training ",
    ],
  },
  {
    id: 4,
    tabTitle: "Compliance",
    heading: "Adaptive Compliance with AI-Powered Regulatory Adherence",
    content:
      "Simplify banking compliance with AI-powered regulatory intelligence. Leverage Gen AI and real-time anomaly detection to ensure adherence to evolving mandates, from AML and KYC to Dodd-Frank. Automate audits, fortify data privacy, and mitigate risks proactively—turning compliance into a competitive advantage.",
    img: managedinfra,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "37,98,72",
    features: [
      "Regulatory Compliance Advisory",
      "Audits & Risk Assessments ",
      "Information Systems & IT Compliance ",
      "Training & Awareness Programs",
    ],
  },
  {
    id: 5,
    tabTitle: "Managed Infra & IT",
    heading: "AI-Optimized IT for Uninterrupted Banking",
    content:
      "Future-proof banking IT with AI-optimized, cloud-native solutions for scalability, security, and resilience. Leverage real-time monitoring, predictive security intelligence, and 24/7 support to eliminate downtimes and ensure uninterrupted banking services. Optimize cloud infrastructure for peak efficiency, agility and sustained performance.",
    img: complaince,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "7,1,112",
    padding: "50px 70px 50px 0px",
    features: [
      "Cloud Advisory ",
      "Cloud Infrastructure Management ",
      "Managed Cybersecurity ",
      "Real-time AI-Powered Monitoring ",
      "Managed IT Services ",
    ],
  },
];

export const enterpriseAiTabs = [
  {
    id: 1,
    tabTitle: "GenAI for Enterprises",
    heading: "AI-Powered Enterprises. Smarter. Faster. Limitless.",
    content:
      "Turbocharge decision-making and efficiency with Gen AI. Automate tasks, optimize workflows, and unify data artifacts into AI-capable formats. Process vast datasets in real time to enhance forecasting and deliver hyper-personalized digital experiences. Achieve in hours what once took months—unlocking unprecedented speed and accuracy.",
    img: genai,
    bgColor: "#031161",
    headingColor: "white",
    useGradient: true,
    gradientColor: "3,18,100",
    features: [
      "AI-Augmented Digital Agents",
      "Intelligent Knowledge Management",
      "AI-Led Hyper-Personalization",
      "Predictive Analytics",
    ],
  },
  {
    id: 2,
    tabTitle: "Agentic AI",
    heading: "Autonomous AI. Intelligent. Adaptive. Always On.",
    content:
      "Transcend traditional automation with Agentic AI by making real-time decisions aligned with business objectives—without constant human oversight. Dynamically adjust strategies and leverage multi-step planning for precision execution. With RAG-powered contextual accuracy and continuous learning, get scalable, enterprise-ready intelligence.",
    img: agentai,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "6,5,68",
    features: [
      "Enterprise-Tailored AI Agents",
      "Interconnected AI Ecosystem",
      "Proactive AI Governance",
    ],
  },
  {
    id: 3,
    tabTitle: "Intelligent Process Automation ",
    heading:
      "Autonomous Process Intelligence. Smarter Workflows, Faster Outcomes.",
    content:
      "Utilize Intelligent Process Automation to mine data across the enterprise and uncover hidden bottlenecks and streamline workflows. Enhance enterprise systems with AI-driven log insights and process intelligence to optimize operations. Bridge legacy system gaps with RPA, enabling seamless automation, integration, and accelerated decision-making.",
    img: inte,
    bgColor: "black",
    headingColor: "white",
    padding: "50px 2px 0px 0px",
    // useGradient: true,
    // gradientColor: "61, 0, 86",
    features: [
      "Process & Task Mining",
      "Cognitive Document Processing",
      "AI-Enhanced Customer Journeys",
    ],
  },
  {
    id: 4,
    tabTitle: "InferIQ",
    heading: "From Unstructured Chaos to AI-Powered Clarity with InferIQ",
    content:
      "Don’t allow unstructured data to slow decision-making and increase operational costs. Transform scattered documents like—PDFs, handwritten forms, images, and scan into structured, actionable insights. With GenAI-powered processing and advanced AWS Textract, accelerate turnaround times, eliminate errors and reduce costs.",
    img: inferiq,
    bgColor: "black",
    headingColor: "white",
    // useGradient: true,
    // gradientColor: "61, 0, 86",
    inferiq: (
      <div>
        Learn more about{" "}
        <a href="https://www.inferiq.ai/" target="_blank">
          InferIQ
        </a>{" "}
        here.
      </div>
    ),
    features: [
      "AI-Enhanced Data Extraction",
      "GenAI-powered Actionable Insights",
      "Seamless Enterprise Integration",
      "Regulatory-Ready Data Processing",
    ],
  },
];

export const dataAnalyticsTabs = [
  {
    id: 1,
    tabTitle: "Data Strategy & Advisory",
    heading: "From Data Chaos to AI-Driven Intelligence",
    content:
      "Harness the power of enterprise applications by integrating data scattered across silos to enhance visibility and unlock actionable insights. Establish structured governance to eliminate inconsistencies, redundancies, and noisy data, ensuring a foundation for high-quality analytics.",
    img: data,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "53,62,112",
    features: [
      "AI-Optimized Data Monetization",
      "Predictive & Prescriptive AI Models",
      "Enterprise-Grade Data Governance & Compliance",
    ],
  },
  {
    id: 2,
    tabTitle: "Data Platform Modernization ",
    heading: "Scalable, Secure, and Cloud-Native Data Ecosystems",
    content:
      "Transform data explosion driven by application proliferation across business functions into opportunities. Adopt a modern data platform to enable real-time processing, high availability, and AI-powered analytics to shift from reactive to proactive decision-making. Extract the most from data before it loses relevance.",
    img: dataplatform,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "54,62,113",
    maxWidth: "100%",
    maxHeight: "350px",
    objectFit: "contain",
    padding: "50px 35px 35px 0px",
    features: [
      "AI-Enabled Data Security & Governance",
      "Scalable, Cloud-Native Data Architecture",
      "Autonomous Data Migration & Optimization",
    ],
  },
  {
    id: 3,
    tabTitle: " Data Intelligence & Visualization",
    heading: "From Raw Data to Real-Time Intelligence",
    content:
      "Uncover raw isolated data to enhance business responsiveness. Democratize insights across the organization while maintaining robust security and privacy standards. Leverage advanced AI-powered visualization and analytics to deliver data in intuitive, actionable formats—empowering teams to identify trends, optimize operations, and secure a competitive edge.",
    img: datainte,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    padding: "50px 70px 35px 0px",
    gradientColor: "54,62,113",
    maxWidth: "100%",
    maxHeight: "450px",
    objectFit: "contain",
    padding: "50px 35px 35px 0px",
    features: [
      "Cognitive Dashboards & AI-Driven Insights",
      "Deep Learning-Enhanced Market Predictions",
      "Behavioral AI for Customer Intelligence",
      "Self-Optimizing Smart Supply Chains",
    ],
  },
];

export const solutionsServicesTabs = [
  {
    id: 1,
    tabTitle: "Custom Application Development",
    heading: "Future-Ready Applications, Built for Agility",
    content:
      "Build, optimize, and future-proof enterprise applications with AI-powered, cloud-native architectures. Use agile methodologies, DevOps automation, and leading frameworks to speed development. Enhance performance, automate maintenance, and cut costs. Ensure resilience with automated testing, intelligent monitoring, and proactive issue resolution.",
    img: custom,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "85,11,93",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      "Cloud-Native Deployment",
      " AIOps-Powered Agile Development",
      " Intelligent Application Lifecycle Management",
      "AI-Engineered Solutions Architecture",
      "Proactive Application Support",
      "Cognitive Test Automation",
    ],
  },
  {
    id: 2,
    tabTitle: "Product Development",
    heading: "AI-Engineered Products Designed for Scale",
    content:"Transform product development with AI-native architectures, hyper-automation, and advanced analytics. Optimize operations with generative AI, streamline workflows with intelligent APIs, and remove bottlenecks with cloud-first microservices. Enhance user experiences with predictive intelligence and seamless ecosystem integration from ideation to production.",
    img: productdev,
    bgColor: "black",
    headingColor: "white",
    useGradient: true,
    gradientColor: "46,65,129",
    maxHeight: "320px",
    objectFit: "contain",
    features: [
      " AI-Native Product Architecture",
      "Gen AI-Driven Operations Transformation",
      "Intelligent API Ecosystem",
      "Built for Cloud Deployment",
      "Agile Development with AIOps",
    ],
  },
  {
    id: 3,
    tabTitle: "System Integration",
    heading: "Seamless, Secure, and Intelligent Enterprise Connectivity",
    content:"Enable seamless data exchange across IT ecosystems with API-driven connectivity. Automate workflows, reduce redundancies, and optimize processes for efficiency. Leverage intelligent automation and data harmonization to build a secure, scalable, and responsive infrastructure that adapts to evolving business needs.",
    img: system,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "28,51,92",
    maxHeight: "360px",
    objectFit: "contain",
    features: [
      "Secure Data Integration",
      "Hyper-Automated Process Optimization",
      "Automated Testing & Validation",
    ],
  },
  {
    id: 4,
    tabTitle: "Managed Infra & IT",
    heading:
      "AI-Optimized IT for Uninterrupted Operations",
    content:"Future-proof IT with AI-driven, cloud-native infrastructure for scalability, security, and resilience. Minimize downtime with predictive intelligence, automate risk mitigation, and optimize workloads. Ensure business continuity with self-healing systems, real-time monitoring, and disaster recovery—adapting dynamically to evolving demands.",
    img: managedinfras,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "102,85,23",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      "Cloud & On-Premise Management",
      "AI-Driven Predictive Monitoring",
      "Next-Gen Security & Compliance",
      "Multichannel 24/7 Intelligent support",
      "Autonomous Data Resilience & Recovery",
    ],
  },
  {
    id: 5,
    tabTitle: "Open-Source Transformation",
    heading: "Accelerate Innovation with Open-Source Ecosystems",
    content:"Drive innovation, cost efficiency, and flexibility with open-source technologies. Enhance performance while avoiding vendor lock-in. Leverage AI-driven modernization, global collaboration, and rapid deployment. Implement AI-powered governance for compliance, making open-source a catalyst for digital transformation.",
    img: open,
    bgColor: "black",
    headingColor: "white",
    padding:" 7px 42px 0px 0px",
    useGradient: true,
    gradientColor: "62,12,12",
    maxHeight: "360px",
    objectFit: "contain",
    features: [
      " Strategic Open-Source Advisory",
      " AI-Powered Application Modernization",
      " Seamless Open-Source Migration",
    ],
  },
];

export const cyberSecurityTabs = [
  {
    id: 1,
    tabTitle: "Identity and Access Management",
    heading: "Secure Access, Minimized Risk",
    content:
      "Ensure only authorized individuals access critical systems, applications, and data. Define roles, enforce strict authentication policies, and prevent unauthorized access across your enterprise. Reduce insider threats and streamline user authentication while maintaining compliance with security regulations. Bring down login fatigue through SSO and MFA to enhance user experience.",
    img: identify,
    bgColor: "black",
    headingColor: "white",
    useGradient: true,
    gradientColor: "76,0,1",
    features: [
      "User Provisioning and Role Based Access Control (RBAC)",
      "Multifactor Authentication and Password Management",
      "User Based Authorization",
      "Access Governance and Identity Federation",
    ],
  },
  {
    id: 2,
    tabTitle: "Threat Detection and Incidence Response",
    heading: "Detect, Respond, and Neutralize Threats Faster",
    content:
      "Detect cyber threats before they escalate into full-scale attacks. Rapidly analyze security incidents, contain breaches, and automate remediation efforts. Strengthen defenses with AI-driven threat intelligence and forensic analysis. Enhance cybersecurity resilience by implementing proactive detection mechanisms, reducing false positives, and ensuring rapid threat mitigation.",
    img: threat,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "10,53,90",
    features: [
      "Threat Intelligence",
      "Intrusion Detection System (IDS)",
      "Incident identification, Containment and Mitigation",
      "Forensic analysis and post incident review",
      "Recovery and remediation",
    ],
  },
  {
    id: 3,
    tabTitle: "Endpoint, Application and Infrastructure Security",
    heading: "End-to-End Protection for Every Digital Touchpoint",
    content:"Protect devices, applications, and infrastructure from cyber threats. Safeguard endpoints across servers, IoT, and mobile workstations while enforcing security policies. Strengthen defenses with advanced threat detection, secure coding, and runtime protection to ensure continuous monitoring and application integrity.",
    img: endpoint,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "10,53,90",
    maxHeight: "450px",
    objectFit: "contain",
    padding: "50px 35px 35px 0px",
    features: [
      "Data Loss Prevention (DLP)",
      "Web filtering",
      "Patch & Configuration Management",
      "Application Security Testing",
      "Zero-Day Threat Mitigation",
    ],
  },
  {
    id: 4,
    tabTitle: "Network Security",
    heading: "Resilient Networks for a Secure Digital Ecosystem",
    content:
      "Protect your network infrastructure against unauthorized access, malware infiltration, and sophisticated cyberattacks. Implement a multi-layered security approach that ensures uninterrupted connectivity and secure data transmission. Establish a security-first approach with network segmentation, encrypted communications, and continuous monitoring to prevent lateral movement by attackers.",
    img: secure,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "20,41,101",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      "Next-Gen Firewalls & Intrusion Prevention System",
      "Encrypted Communication Channels",
      "Micro segmentation & Network Access Control",
      "Zero Trust Architecture",
      "AI-Driven Anomaly Detection",
    ],
  },
  {
    id: 5,
    tabTitle: "Data Security and Protection",
    heading: "Safeguard Sensitive Information at Every Layer",
    content:"Prevent data breaches with a robust data security strategy. Implement encryption and access controls to ensure data confidentiality and integrity across cloud and on-premise environments. Leverage AI-powered anomaly detection to identify suspicious data activities. Strengthen data resilience with automated backup and disaster recovery mechanisms to prevent loss from cyber incidents.",
    img: datasecure,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "4,39,41",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      "End-to-End Data Encryption",
      "Data Leak Prevention",
      "Access & Usage Monitoring",
      "Regulatory Compliance Enforcement",
    ],
  },
  {
    id: 6,
    tabTitle: "Vulnerability and Risk Management",
    heading: "Identify, Assess, and Mitigate Cyber Risks",
    content:"Detect security vulnerabilities, assess potential risks, and implement mitigation strategies to fortify your security posture. Adopt a risk-based approach, prioritizing vulnerabilities that pose the highest threat to business continuity. Enhance cyber resilience with predictive risk modeling and proactive remediation strategies that evolve with new attack vectors.",
    img: risk,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "18,65,24",
    maxHeight: "370px",
    // objectFit: "contain",
    features: [
      "Automated Vulnerability Scanning",
      "Risk-Based Prioritization",
      "Continuous Security Posture Management",
    ],
    inferiq: (
      <div>
        Please read our{" "}
        <a href="resources/Technical-Vulnerabilities-Document.pdf" target="_blank">
          Technical Vulnerabilities 
        </a>{" "}
        policy here.
      </div>
    ),
  },
];

export const cloudServicesTabs = [
  {
    id: 1,
    tabTitle: "Cloud Advisory",
    heading: "Align Your Cloud Journey with Business Goals",
    content:
      "Redefine cloud adoption with a strategy tailored to your enterprise. Align workloads, choose the right model, and optimize governance. Implement hybrid, multi-cloud, or cloud-native architectures to enhance agility, security, and efficiency—maximizing ROI with intelligent workload distribution and cost-effective management.",
    img: cloudad,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "77,36,36",
    // maxWidth: "100%",
    // maxHeight: "400px",
    // objectFit: "contain",
    padding: "50px 70px 0px 0px",
    flex: "none",
    width: "auto",
    features: [
      "Cloud Strategy and Roadm",
      "Cloud Cost Optimization",
      "Cloud Architecture and Design",
      "Governance and Operations",
    ],
  },
  {
    id: 2,
    tabTitle: "Migration Services",
    heading: "Seamless Transition with Minimal Downtime",
    content:
      "Accelerate cloud migration with structured frameworks. Move from on-prem to cloud or across clouds with a disaster recovery strategy. Leverage the 7Rs for optimized transitions. Ensure secure, compliant, and disruption-free workload migration across AWS, Azure, and Google Cloud Platform.",
    img: migrationservice,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "15,13,98",
      maxHeight: "360px",
    objectFit: "contain",
    features: [
      "Assessment and Planning",
      "Infrastructure Migration",
      "Application Migration",
      "Data Migration",
      "Hybrid Cloud Integration",
    ],
  },
  {
    id: 3,
    tabTitle: "Managed Services",
    heading: "Optimize and Scale with 24/7 Support",
    content:
      "Eliminate cloud complexities with end-to-end management. Provision, monitor, and secure cloud servers while implementing 24/7 cybersecurity. Optimize costs, ensure high availability, and automate backups across hybrid and multi-cloud environments. With trusted partners, leave reliability and efficiency to the experts.",
    img: managedservice,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "0,50,98",
maxWidth: "100%",
    padding: "74px 0px 0px 0px",
    features: [
      "Compute Services",
      "Storage and Backup Services",
      "Networking and Connectivity",
      "Logging, Monitoring, and Observability",
      "Database and Data Management Services",
    ],
  },
  {
    id: 4,
    tabTitle: "Cloud Native Development",
    heading: "Build and Deploy with Cloud-First Technologies",
    content:
      "Design applications that harness cloud capabilities. Develop cloud-native architectures using microservices, Kubernetes, and serverless computing to improve scalability, flexibility, and resilience. Modernize legacy systems and integrate AI-powered insights for better efficiency. Implement disaster recovery strategies that ensure business continuity.",
    img: cloudnative,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "58,45,95",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      "Microservices Based Architecture",
      "Application Containerization",
      "API-First Development",
      "Serverless Computing",
      "Infrastructure as Code (IaC)",
    ],
  },
  {
    id: 5,
    tabTitle: "Cloud Security and Compliance",
    heading: "Adaptive Security for an Evolving Threat Landscape",
    content:
      "Implement Zero Trust security framework to safeguard cloud environments. Enforce least privilege access, encrypt data, and monitor anomalous activities. Ensure compliance with SOC2, ISO 27001, and NIST SP 800-53 standards. Deploy advanced threat detection, automated remediation, and identity-based security to fortify cloud workloads.",
    img: cloudsecurity,
    bgColor: "#FFEEE2",
    headingColor: "white",
    useGradient: true,
    gradientColor: "106,52,114",
    maxHeight: "400px",
    objectFit: "contain",
    features: [
      " Cloud Compliance Frameworks",
      " Threat Protection and Monitoring",
      " Data Security",
      " Identity and Access Management (IAM)",
    ],
  },
];
